import axios from "../../lib/axiosInstance";

// Country/city data now comes from our own backend (geo module) instead of the
// external RestCountries / countriesnow services. Each function re-maps the
// backend response to the exact shape the existing consumers already expect, so
// no hook or component had to change:
//   - fetchCountries     -> { data: [{ name: { common }, cca2 }] }   (RestCountries /all shape)
//   - fetchCountryByCode -> { data: { name: { common }, cca2 } }     (RestCountries /alpha shape)
//   - fetchCities        -> { data: [<cityName>] }                   (countriesnow shape)

export async function fetchCountries() {
  const res = await axios.get("countries");
  const data = (res?.data?.data ?? []).map((country) => ({
    name: { common: country.name },
    cca2: country.iso2,
  }));
  return { data };
}

export async function fetchCountryByCode(code) {
  const res = await axios.get(`countries/by-code/${code}`);
  const country = res?.data?.data;
  return {
    data: country ? { name: { common: country.name }, cca2: country.iso2 } : null,
  };
}

export async function fetchCities(payload) {
  const country = payload?.country ?? "";
  const res = await axios.get(
    `countries/by-name/${encodeURIComponent(country)}/cities`,
  );
  return { data: res?.data?.data ?? [] };
}

// Paginated + searchable city lookup for infinite-scroll dropdowns. Returns one
// page (default 20) of city-name strings plus `{ hasNextPage }` so the caller
// knows whether to fetch the next page on scroll.
export async function fetchCitiesPaginated({ country, page = 1, limit = 20, q = "" }) {
  const res = await axios.get(
    `countries/by-name/${encodeURIComponent(country ?? "")}/cities`,
    { params: { page, limit, ...(q ? { q } : {}) } },
  );
  return {
    data: res?.data?.data ?? [],
    meta: res?.data?.meta ?? { page, limit, hasNextPage: false },
  };
}
